import DocumentCodeAndTimestamp from './DocumentCodeAndTimestamp';

export default DocumentCodeAndTimestamp;
